import { postGetCustomerOrderListByOrderIdList } from "../../request/designordercenter/internal/customerOrder/getCustomerOrderListByOrderIdList/post.js";
import { getCheckWhitelistByBusinessTypeAndBusinessId } from "../../request/internal/whitelist/checkWhitelistByBusinessTypeAndBusinessId/get.js";
async function customerOrderCheckSpecial(businessId) {
  if (!businessId)
    throw new Error(`\u4F7F\u7528customerOrderCheckSpecial\u65B9\u6CD5\u68C0\u67E5\u662F\u5426\u5728\u6309\u5BA2\u767D\u540D\u5355\u5FC5\u987B\u4F20\u5165businessId\u53C2\u6570`);
  return await getCheckWhitelistByBusinessTypeAndBusinessId({ businessType: "customer_order", businessId });
}
async function opCustomerOrderCheckSpecialBySource(source) {
  return ![
    "JJJR",
    "mtds_field_erection_code",
    "mtds_store_build",
    "opyc_mall",
    "jpxcx_mall",
    "cdxcx_mall",
    "mjxcx_mall",
    "zzdjj_mall",
    "jtscxcx_mall",
    "MTDSmobile"
  ].includes(source);
}
async function customerOrderCheckSpecialByOrderIds(idList) {
  const res = await postGetCustomerOrderListByOrderIdList({ orderIdList: idList });
  return (res == null ? void 0 : res.length) === idList.length;
}
export { customerOrderCheckSpecial, customerOrderCheckSpecialByOrderIds, opCustomerOrderCheckSpecialBySource };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/utils/checkSpecial/customerOrderCheckSpecial.js